import React, { useContext } from 'react';
// import '../styles/TiendaSeleccionada.css';
import { FormContext } from '../context/FormContext';

const TiendaSeleccionada = () => {
    const { formData } = useContext(FormContext);
      //  console.log("form context" , formData);
    
    return (
       
        <div className="row booking-resume-location mb20">
          <div className="col-2">
            <img
              src="https://cdn.shopify.com/s/files/1/0015/7610/8121/files/ico_gmo1.png?v=1724945945"
              alt=""
              className="img-fluid"
            />
          </div>
          <div className="col-10">
            <div className="basic-booking-info">
              <h6 className="monts-b basic-booking-info-store">
                {formData.TiendaSeleccionada?.nombre || "No seleccionada"}
              </h6>
              <p className="basic-booking-info-address">
                {formData.TiendaSeleccionada?.direccion || "Sin dirección"}
                <br />
                {/* {formData.TiendaSeleccionada?.ubicacion || "Sin ubicación"} */}
              </p>
            </div>
          </div>
          <div className="col-12 text-center">
          <a
  href={
    formData.TiendaSeleccionada.cfg_latitud && formData.TiendaSeleccionada.cfg_longitud // Verificar que ambas coordenadas existan
      ? `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
          `${formData.TiendaSeleccionada.cfg_latitud.replace(",", ".")},${formData.TiendaSeleccionada.cfg_longitud.replace(",", ".")}`
        )}`
      : "#"
  }
  target="_blank"
  rel="noopener noreferrer"
  onClick={(e) => {
    if (!formData.TiendaSeleccionada.cfg_latitud || !formData.TiendaSeleccionada.cfg_longitud) {
      e.preventDefault(); // Evitar que el enlace intente navegar si no hay coordenadas válidas
      console.warn("Las coordenadas no están disponibles.");
    }
  }}
> <p className="direction-button">
                    CÓMO LLEGAR
        </p>
</a>
          </div>
        </div>
   
  
    );
};






export default TiendaSeleccionada;